import React, { useEffect, useRef } from "react";
import Inputmask from "inputmask";
import {
  BooleanInput,
  FormDataConsumer,
  Record,
  regex,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useTranslate,
} from "react-admin";
import { TenantDomainNameInput } from "../tenants/TenantDomainNameInput";
import { TenantAdminNameInput } from "../tenants/TenantAdminNameInput";
import {
  TenantRegistrationStatus,
  TenantRegistrationType,
} from "../../../common/data/service-proxies";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";
import permissionNames from "../../../common/auth/access-control/permissionNames";

interface Props {
  edit?: boolean;
  record?: Record;
}

const tenantRegistrationTypes = [
  { id: TenantRegistrationType.Fleet, name: TenantRegistrationType.Fleet },
  { id: TenantRegistrationType.Master, name: TenantRegistrationType.Master },
];

export const TenantRegistrationForm = (props: Props) => {
  const actionPermissions = useActionPermissions();
  const { edit, ...rest } = props;
  const { record } = rest;
  const translate = useTranslate();
  const phoneRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (!phoneRef.current) {
      return;
    }

    var im = new Inputmask("(999) 999-9999");
    im.mask(phoneRef.current);
  });

  return (
    <SimpleForm className="form-create-edit" variant="outlined" {...rest}>
      <TextInput
        source="name"
        label="resources.master-tenants.labels.name"
        validate={required()}
        autoComplete="company-name"
      />
      <TextInput
        source="customerContactName"
        label="resources.master-tenants.labels.customerContactName"
        validate={required()}
      />
      <TextInput
        source="customerContactPhone"
        inputRef={phoneRef}
        label="resources.master-tenants.labels.customerContactPhone"
        validate={[required()]}
      />
      <TextInput
        source="customerContactEmail"
        label="resources.master-tenants.labels.customerContactEmail"
        validate={required()}
      />
      <TenantDomainNameInput
        source="domainName"
        label="resources.master-tenants.labels.domainName"
        validate={[
          required(),
          regex(
            /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/,
            translate("resources.master-tenants.labels.mustBeValidDomainName")
          ),
        ]}
      />
      <TenantAdminNameInput
        defaultValue="Administrator"
        source="adminName"
        label="resources.master-tenants.labels.adminName"
        validate={[required()]}
      />
      <TextInput
        disabled={edit && record?.status === TenantRegistrationStatus.Active}
        source="adminEmailAddress"
        label="resources.master-tenants.labels.adminEmailAddress"
        validate={required()}
        inputProps={{
          autoComplete: "new-password",
        }}
      />
      <FormDataConsumer>
        {({ getSource, scopedFormData, formData, ...rest }) => {
          console.log(formData);
          return edit &&
            actionPermissions[
              permissionNames.admin.tenantRegistrations.manage
            ] &&
            formData.tenantRegistrationStatus ===
              TenantRegistrationStatus.Active ? (
            <SelectInput
              {...rest}
              source={
                getSource
                  ? getSource("tenantRegistrationType")
                  : "tenantRegistrationType"
              }
              label="resources.master-tenants.labels.tenantRegistrationType"
              choices={tenantRegistrationTypes}
            />
          ) : null;
        }}
      </FormDataConsumer>

      <BooleanInput
        source="hasOwnElds"
        label="resources.master-tenants.labels.hasOwnElds"
      />
    </SimpleForm>
  );
};
